import type { CategoryContent } from '../../row.js';

/**
 * Geschiedenis & beschavingen, tweede reeks.
 *
 * Geschreven met het juiste antwoord steeds eerst; een rotatie bij het bouwen
 * verspreidt de geschreven antwoordindex over alle vier de posities, dus de
 * positie van het antwoord hier draagt geen informatie en hoeft dat ook niet.
 */
export const MORE_HISTORY: CategoryContent = {
  msc: [
    [
      'Wat regelde de Gouden Bul van 1356?',
      [
        'De verkiezing van de Rooms-Duitse keizer door een vast college van zeven prins-kiezers',
        'De rechtsmacht van keizerlijke hoven over de vrije steden van het Rijk',
        'Het recht van de vorsten van het Rijk om munten te slaan binnen hun gebieden',
        'De verplichting van keizerlijke leenmannen om troepen te leveren voor Italiaanse veldtochten',
      ],
      0,
      'Karel IV legde de kiesprocedure vast en maakte haar onafhankelijk van pauselijke bevestiging. Ze bleef, in essentie ongewijzigd, van kracht tot 1806.',
    ],
    [
      'Waardoor is de Vrede van Karlowitz (1699) van belang?',
      [
        'Het is de eerste grote Ottomaanse afstand van Europees grondgebied',
        'Het is het verdrag dat voor het eerst Russische toegang tot de Zwarte Zee erkende namens de Ottomanen',
        'Het is de regeling die de Oorlog van de Heilige Liga beëindigde zonder gebiedswisseling',
        'Het is de overeenkomst die permanente Ottomaanse ambassades in Europese hoofdsteden vestigde',
      ],
      0,
      'Hongarije en Transsylvanië gingen over naar de Habsburgers. Het keerde de richting van de grens voor het eerst sinds de veertiende eeuw.',
    ],
    [
      'Door wie werd de Raad van Beroerten, bekend als de Bloedraad, ingesteld?',
      [
        'De hertog van Alva, als landvoogd in de Nederlanden',
        'Filips II persoonlijk, tijdens zijn enige bezoek aan de noordelijke gewesten',
        'Margaretha van Parma, vóór haar terugroeping naar Spanje in 1567',
        'Kardinaal Granvelle, in het kader van de herindeling van de bisdommen',
      ],
      0,
      'Ingesteld in 1567 om deelnemers aan de Beeldenstorm te berechten, en een betrouwbare aanjager van de opstand die zij juist moest onderdrukken.',
    ],
    [
      'In welk jaar werden de Corn Laws ingetrokken?',
      ['1846', '1832', '1867', '1815'],
      0,
      'Peel verdeelde zijn eigen partij om het door te zetten, midden in de Ierse hongersnood. 1815 is het jaar waarin de strengste versie werd ingevoerd.',
    ],
    [
      'Welk beginsel legde de Conferentie van Berlijn van 1884-85 vast?',
      [
        'Dat aanspraak op Afrikaans grondgebied aantoonbare effectieve bezetting vereiste',
        'Dat bestaande Afrikaanse rijken zouden worden erkend als soevereine staten',
        'Dat het Congobekken gezamenlijk zou worden bestuurd door de deelnemende machten',
        'Dat de Atlantische slavenhandel zou worden onderdrukt door een gezamenlijke marinepatrouille',
      ],
      0,
      'Het regelde de concurrentie tussen de Europese machten en kende geen Afrikaanse vertegenwoordiging. Congo ging naar Leopold II persoonlijk, niet naar een condominium.',
    ],
    [
      'Waar hadden de Constituties van Clarendon (1164) betrekking op?',
      [
        'De grens tussen kerkelijke en koninklijke rechtsmacht in Engeland',
        'De verplichtingen van hoofdleenmannen tot krijgsdienst aan de kroon',
        'De procedures voor het vaststellen en innen van de gelden',
        'De rechten van het woud en de straffen voor overtreding daarvan',
      ],
      0,
      'Hendrik II\'s poging om het gewoonterecht te codificeren tegen kerkelijke privileges. Beckets weigering om dit te aanvaarden is de directe aanleiding voor zijn moord, zes jaar later.',
    ],
    [
      'Wat deed de "eerste regeling" van 27 v.Chr.?',
      [
        'Herstelde formeel de Republiek terwijl buitengewone machten werden geconcentreerd bij Augustus',
        'Schafte de Senaat af als bestuursorgaan ten gunste van een keizerlijke raad',
        'Creëerde het ambt van keizer als een omschreven staatsrechtelijk magistraat',
        'Verdeelde het rijk bestuurlijk tussen Augustus en Agrippa',
      ],
      0,
      'De fictie van herstel was juist het punt: Augustus bekleedde geen enkel ambt dat formeel nieuw was, wat verklaart waarom de overgang zo moeilijk te dateren is.',
    ],
    [
      'Door welke staat werden de Tanzimat-hervormingen doorgevoerd?',
      [
        'Het Ottomaanse Rijk',
        'Qajar-Perzië, onder Nasir al-Din Shah',
        'Meiji-Japan, in zijn eerste decennium',
        'Het Egypte van Muhammad Ali, terwijl het nog nominaal Ottomaans was',
      ],
      0,
      'Van 1839 tot 1876: rechtsgelijkheid, een nieuw handelsrecht, dienstplicht en gecentraliseerde belastingheffing. Ook Egypte hervormde, maar dat is een apart programma.',
    ],
    [
      'Waarnaar verwijst de Mfecane?',
      [
        'Een periode van omwenteling, migratie en staatsvorming in zuidelijk Afrika in het begin van de negentiende eeuw',
        'De aan Shaka toegeschreven Zoeloe-militaire hervormingen en hun verspreiding naar het noorden',
        'De grensoorlogen tussen de Kaapkolonie en de Xhosa-rijken',
        'De trek van boeren landinwaarts vanaf de Kaap naar het hoogveld, en de daaropvolgende grensconflicten',
      ],
      0,
      'De Zoeloe-hervormingen zijn slechts één element ervan. Of het vooral werd veroorzaakt door Zoeloe-expansie, door slavenroof vanuit Delagoabaai, of door droogte staat volop ter discussie.',
    ],
    [
      'Wat deed het Statuut van Westminster van 1931?',
      [
        'Gaf de Dominions wetgevende onafhankelijkheid van het parlement van Westminster',
        'Vestigde het Gemenebest als een formele internationale organisatie',
        'Bracht de verantwoordelijkheid voor het buitenlands beleid van de Dominions over naar Londen',
        'Creëerde een recht van beroep van rechtbanken in de Dominions naar de Kroonraad',
      ],
      0,
      'Het gaf uitvoering aan de Balfour-verklaring van 1926. Ierland, Canada en Zuid-Afrika namen het onmiddellijk aan; Australië en Nieuw-Zeeland wachtten jaren.',
    ],
  ],
  phd: [
    [
      'Door welke overeenkomst werd de Investituurstrijd beslecht?',
      [
        'Het Concordaat van Worms, in 1122',
        'De Vrede van Venetië, in 1177',
        'Het Concordaat van Bologna, in 1516',
        'De Dictatus Papae, uitgevaardigd in 1075',
      ],
      0,
      'Bisschoppen zouden met het geestelijk ambt bekleed worden door de kerk en met de wereldlijke regalia door de keizer. De Dictatus Papae is Gregorius VII die de twist opent, niet afsluit.',
    ],
    [
      'Met wie wordt de these van de "militaire revolutie" vooral geassocieerd?',
      [
        'Michael Roberts, later grondig herzien door Geoffrey Parker',
        'Charles Tilly, in zijn werk over dwang en kapitaal',
        'Paul Kennedy, in zijn verhaal over de opkomst en het verval van grote machten',
        'William McNeill, in zijn werk over het streven naar macht',
      ],
      0,
      'Roberts plaatste haar in Zweden tussen 1560 en 1660; Parker rekte de chronologie en verlegde de nadruk naar vestingbouw en zeemacht.',
    ],
    [
      'Wat was de Ottomaanse devshirme?',
      [
        'Een lichting van christelijke jongens uit de Balkan voor militaire en bestuurlijke dienst',
        'Een landtoewijzingssysteem ter ondersteuning van provinciale cavalerie in ruil voor dienst',
        'De belasting die niet-moslimonderdanen betaalden in plaats van militaire dienst',
        'De praktijk om provinciale gouverneurs te rouleren om lokale verankering te voorkomen',
      ],
      0,
      'Zij bemande zowel de janitsaren als de hoogste ambten van de staat. Het landtoewijzingssysteem is de timar en de belasting is de jizya.',
    ],
    [
      'Welke concurrerende verklaringen bestaan voor de zestiende-eeuwse prijsrevolutie?',
      [
        'Monetaire expansie door Amerikaans zilver',
        'Muntverzwakking, tegenover de instorting van de Baltische graanexport',
        'Loonvorming door gilden, tegenover de omheining van gemeenschappelijke grond',
        'Ottomaanse verstoring van de oostelijke handel, tegenover de verschuiving van routes naar de Atlantische Oceaan',
      ],
      0,
      'Hamiltons zilverthese tegenover het demografische betoog van Postan en anderen. Relatieve prijzen - voedsel dat het snelst stijgt - zijn wat de monetaire verklaring moeilijk kan verantwoorden.',
    ],
    [
      'Wat beoogde de Pragmatieke Sanctie van 1713?',
      [
        'De Habsburgse landen ondeelbaar houden en vrouwelijke opvolging daarin toestaan',
        'De protestantse troonopvolging in het Heilige Roomse Rijk waarborgen',
        'De verdeling van de Spaanse erfenis onder de pretendenten regelen',
        'De staatsrechtelijke verhouding tussen Hongarije en de Habsburgse kroon vastleggen',
      ],
      0,
      'Karel VI besteedde zijn regering aan het kopen van erkenning ervoor, en de machten verwierpen haar toch binnen enkele maanden na zijn dood.',
    ],
    [
      'De Vrede van Jam Zapolski (1582) beëindigde de strijd tussen Moskovië en welke macht?',
      [
        'Polen-Litouwen',
        'Zweden, dat Narva onder de bepalingen behield',
        'De Lijflandse Orde, toen al in ontbinding',
        'Het Krim-khanaat en zijn Ottomaanse beschermheren',
      ],
      0,
      'Ivan IV gaf zijn Lijflandse aanspraken op aan Báthory. De afzonderlijke wapenstilstand met Zweden, bij Plussa, volgde het jaar daarna.',
    ],
    [
      'Wat leverde de Rijksdag van Spiers in 1529 op?',
      [
        'Het formele protest waaraan het woord protestant zijn naam ontleent',
        'De eerste keizerlijke erkenning van lutherse territoriale kerken',
        'De geloofsbelijdenis die Melanchthon aan de keizer voorlegde',
        'De opschorting van het Edict van Worms in het gehele Rijk',
      ],
      0,
      'De minderheid protesteerde tegen de herroeping van de concessie van 1526. De belijdenis kwam het jaar daarna, in Augsburg.',
    ],
    [
      'Wat bracht de Slag bij Sekigahara in 1600 tot stand?',
      [
        'Tokugawa-overheersing over Japan',
        'De eenmaking van Japan onder de regenten van Toyotomi Hideyoshi',
        'De verdrijving van Portugese handelaren van de Japanse eilanden',
        'Het einde van de Onin-oorlog en het begin van het Sengoku-tijdvak',
      ],
      0,
      'Ieyasu nam drie jaar later de titel shogun aan. Het Sengoku-tijdvak begint met de Onin-oorlog in 1467, ruim een eeuw eerder.',
    ],
    [
      'Wat deed het Sykes-Picot-akkoord van 1916?',
      [
        'Verdeelde de Ottomaanse Arabische provincies in geprojecteerde Franse en Britse invloedssferen',
        'Beloofde een onafhankelijk Arabisch koninkrijk in ruil voor opstand tegen de Ottomanen',
        'Vestigde het mandaatsysteem onder de Volkenbond',
        'Verdeelde Anatolië tussen Griekenland, Italië en Frankrijk',
      ],
      0,
      'De Hussein-McMahon-correspondentie is de belofte van Arabische onafhankelijkheid, en de onverenigbaarheid van beide is de kern van de grief.',
    ],
    [
      'In welke eeuw bereikte de Atlantische slavenhandel zijn hoogste volume?',
      ['De achttiende', 'De zeventiende', 'De negentiende', 'De zestiende'],
      0,
      'Ongeveer zes van de twaalf en een half miljoen ingescheepten werden in de achttiende eeuw vervoerd. De volumes bleven hoog tot in de negentiende eeuw, ondanks afschaffing.',
    ],
  ],
  professor: [
    [
      'Wat stelt de Pirenne-these?',
      [
        'Dat de islamitische expansie, niet de Germaanse invasies, de eenheid van het Middellandse Zeegebied verbrak en het zwaartepunt van Europa naar het noorden verlegde',
        'Dat de Romeinse economie al was ingestort vóór er enige invasie plaatsvond',
        'Dat de Karolingische renaissance continu was met de laatantieke cultuur',
        'Dat het stedelijk leven in het westen ononderbroken voortleefde tot in de achtste eeuw, zonder onderbreking van de handel in het Middellandse Zeegebied',
      ],
      0,
      'Mohammed en Karel de Grote, postuum gepubliceerd in 1937. Archeologie heeft de scherpe breuk ondermijnd, maar de vraag die het opwierp is nooit teruggetrokken.',
    ],
    [
      'Met wie wordt de these van de "algemene crisis" van de zeventiende eeuw geassocieerd, en hoe is deze herzien?',
      [
        'Trevor-Roper en Hobsbawm, later herzien rond het klimaat van de Kleine IJstijd door Parker',
        'Braudel en de Annales-school, later herzien rond prijsreeksen',
        'Wallerstein en de wereldsysteemtheorie, later herzien rond handelsafhankelijkheid',
        'North en Thomas, later herzien rond institutionele eigendomsrechten',
      ],
      0,
      'Global Crisis (2013) brengt het klimatologische betoog samen. De herziening is belangrijk omdat zij een Europees debat tot een mondiaal debat maakt.',
    ],
    [
      'Door welke nadruk kenmerkt de Annales-school zich?',
      [
        'Langetermijnstructuren en het materiële leven boven het narratief van gebeurtenissen',
        'De voorrang van het politieke narratief, gereconstrueerd uit staatsarchieven',
        'Kwantitatieve toetsing van hypothesen ontleend aan de neoklassieke economie',
        'Het terugvinden van individuele ervaring door nauwgezette lezing van rechtszaakverslagen',
      ],
      0,
      'Bloch, Febvre en daarna Braudels longue durée. Microhistorie - Ginzburg, Le Roy Ladurie - is een deels reactieve latere ontwikkeling.',
    ],
    [
      'Door wie werd de Constitutum Constantini aangetoond als vervalsing?',
      [
        'Lorenzo Valla, waarbij Nicolaas van Cusa onafhankelijk tot dezelfde conclusie kwam',
        'Erasmus, tijdens de voorbereiding van zijn Griekse Nieuwe Testament',
        'Marsilius van Padua, in Defensor Pacis',
        'Petrarca, in zijn brieven over de terugkeer van het pausdom naar Rome',
      ],
      0,
      'Valla\'s declamatie uit 1440 is het klassieke voorbeeld van filologische methode toegepast op een politiek document.',
    ],
    [
      'Door wie werd de term "Columbiaanse uitwisseling" bedacht?',
      [
        'Alfred Crosby',
        'William Cronon, in Changes in the Land',
        'Charles Mann, in 1493',
        'Jared Diamond, in Zwaarden, Paarden en Ziektekiemen',
      ],
      0,
      'Crosby, 1972. De andere drie bouwen alle op dat werk voort, wat een goede maatstaf is voor hoeveel werk het begrip heeft verricht.',
    ],
    [
      'Wat beweerde het concept van de "fiscaal-militaire staat" over het achttiende-eeuwse Groot-Brittannië?',
      [
        'Dat de macht rustte op belastingcapaciteit en publiek krediet, niet op absolutistisch gezag',
        'Dat alleen zeemacht het voordeel ten opzichte van Frankrijk verklaart',
        'Dat parlementaire soevereiniteit oorlogvoering beperkte ten opzichte van rivalen',
        'Dat koloniale handelsinkomsten de oorlogen financierden zonder binnenlandse belastingen',
      ],
      0,
      'Brewers Sinews of Power. De paradox die het verklaart is een staat met een zwak dwangapparaat die per hoofd meer inkomsten wist te heffen dan de absolute monarchieën.',
    ],
    [
      'Waarom is het Karolingische minuskel van belang voor de overlevering van klassieke teksten?',
      [
        'Het standaardiseerde een leesbaar, met spaties gescheiden schrift waarin de meeste bewaard gebleven afschriften zijn gemaakt',
        'Het was het eerste schrift dat met een rietpen werd geschreven in plaats van een stilus',
        'Het maakte het gebruik van perkament mogelijk in plaats van papyrus voor lange werken',
        'Het introduceerde de codexvorm in plaats van de boekrol',
      ],
      0,
      'Het meeste klassieke Latijn is overgeleverd via negende-eeuwse afschriften. Renaissance-humanisten verwarden het schrift met Romeins schrift, wat verklaart waarom ons romein-lettertype hiervan afstamt.',
    ],
    [
      'Waar gaat het "Great Divergence"-debat over?',
      [
        'Wanneer en waarom de economische ontwikkelingslijnen van West-Europa en China zich uit elkaar begaven',
        'Waarom de industrialisatie in Groot-Brittannië begon in plaats van in de Lage Landen',
        'De kloof tussen koloniale en moederlandse levensstandaard na 1800',
        'De uiteenlopende groei van Noord- en Zuid-Europa na de Zwarte Dood',
      ],
      0,
      'Pomeranz legde de splitsing laat en zocht de verklaring in steenkool en kolonies; de California school tegenover de eerdere ramingen van Broadberry en Allen is het levende debat.',
    ],
    [
      'Onder wie werd de Corpus Juris Civilis samengesteld, en wat omvat het?',
      [
        'Justinianus - de Codex, de Digesten, de Instituten en de latere Novellen',
        'Theodosius II - alleen de Codex, ter vervanging van alle eerdere keizerlijke constituties',
        'Diocletianus - de Gregoriaanse en Hermogeniaanse verzamelingen',
        'Leo VI - de Basilika, die eerder recht in het Grieks herformuleerde',
      ],
      0,
      'De Digesten zijn het deel dat er echt toe deed: hun herontdekking in Bologna in de elfde eeuw is de grondslag van de westerse civielrechtelijke traditie.',
    ],
    [
      'Waarnaar verwijst de "zwarte legende"?',
      [
        'Een geheel van anti-Spaans schrijven dat koloniale gruwelijkheden benadrukte, waarvan veel werd verspreid door de rivalen van Spanje',
        'De historiografische claim dat het Spaanse verval begon onder Filips II',
        'Het verslag van de inquisitie zoals gegeven door protestantse ballingen uit de Nederlanden',
        'De traditie die het falen van de Armada toeschrijft aan goddelijk ingrijpen',
      ],
      0,
      'Zij leunt sterk op Las Casas, die zelf Spaans was en schreef om de Spaanse praktijk te hervormen - wat het propagandistisch gebruik van zijn werk zo complex maakt.',
    ],
  ],
};
